import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../components/TableHorizontal'

interface InventoryCasesTableProps {
  cases: TableHorizontalData[]
}

export default class InventoryCasesTable
  extends Component<InventoryCasesTableProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n('ItemCode'), path: 'originalItemCode' },
    { heading: i18n('Position'), path: 'position' },
    { heading: i18n('CaseCode'), path: 'code' },
    { heading: i18n('Quantity'), path: 'quantity' },
    {
      heading: i18n('Created at'),
      path: 'inventory.createdAt',
      date: true,
      tooltip: ['inventory.createdUser.username']
    }
  ]

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Cases")} />
        <TableHorizontal
          headers={this.headers}
          data={this.props.cases} />
      </Card>
    )
  }
}
